<script lang="ts">
	import type { ComponentSectionsSteps } from '$lib/graphql/strapiApi';

	let { content }: { content: ComponentSectionsSteps } = $props();
</script>

<div class="flex flex-col gap-12">
	{#if content.title}
		<div class="text-center">
			<h2 class="text-3xl font-bold tracking-tight sm:text-4xl">{content.title}</h2>
			{#if content.description}
				<p class="mt-4 text-lg text-muted-foreground">{content.description}</p>
			{/if}
		</div>
	{/if}

	{#if content.steps && content.steps.length > 0}
		<div class="space-y-12">
			{#each content.steps as step, index}
				{#if step}
					<div class="flex flex-col lg:flex-row gap-8 lg:gap-12">
						<!-- Step Number and Header -->
						<div class="lg:w-1/3">
							<div class="flex items-start gap-4">
								<div
									class="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground font-bold text-lg"
								>
									{step.stepNumber}
								</div>
								<div class="flex-1">
									<h3 class="text-xl font-bold">{step.title}</h3>
									{#if step.subTitle}
										<p class="text-sm text-muted-foreground mt-1">{step.subTitle}</p>
									{/if}
									{#if step.timeframe}
										<div class="mt-2 flex items-center gap-2">
											<svg
												class="h-4 w-4 text-muted-foreground"
												fill="none"
												stroke="currentColor"
												viewBox="0 0 24 24"
											>
												<circle cx="12" cy="12" r="10" />
												<polyline points="12,6 12,12 16,14" />
											</svg>
											<span class="text-sm text-muted-foreground">Timeframe: {step.timeframe}</span>
										</div>
									{/if}
								</div>
							</div>
							{#if step.richDescription?.body || step.description}
								<p class="mt-4 text-sm text-muted-foreground">{@html step.richDescription?.body || step.description}</p>
							{/if}
						</div>

						<!-- Tasks -->
						<div class="lg:w-2/3 grid gap-6 md:grid-cols-2">
							<!-- Your Tasks -->
							{#if step.leftTasks && step.leftTasks.length > 0}
								<div class="rounded-lg border p-6">
									<h4 class="text-lg font-semibold mb-4 text-blue-600">Your Tasks:</h4>
									<ul class="space-y-2">
										{#each step.leftTasks as task}
											{#if task}
												<li class="flex items-start gap-2">
													<svg
														class="h-4 w-4 mt-1 text-blue-600 shrink-0"
														fill="none"
														stroke="currentColor"
														viewBox="0 0 24 24"
													>
														<polyline points="20,6 9,17 4,12" />
													</svg>
													{#if task.url}
														<a href={task.url} class="text-sm hover:underline">{task.text}</a>
													{:else}
														<span class="text-sm">{task.text}</span>
													{/if}
												</li>
											{/if}
										{/each}
									</ul>
								</div>
							{/if}

							<!-- MVMNT's Tasks -->
							{#if step.rightTasks && step.rightTasks.length > 0}
								<div class="rounded-lg border p-6 bg-primary/5">
									<h4 class="text-lg font-semibold mb-4 text-primary">MVMNT's Tasks:</h4>
									<ul class="space-y-2">
										{#each step.rightTasks as task}
											{#if task}
												<li class="flex items-start gap-2">
													<svg
														class="h-4 w-4 mt-1 text-primary shrink-0"
														fill="none"
														stroke="currentColor"
														viewBox="0 0 24 24"
													>
														<polyline points="20,6 9,17 4,12" />
													</svg>
													{#if task.url}
														<a href={task.url} class="text-sm hover:underline">{task.text}</a>
													{:else}
														<span class="text-sm">{task.text}</span>
													{/if}
												</li>
											{/if}
										{/each}
									</ul>
								</div>
							{/if}
						</div>
					</div>

					<!-- Progress Line (not on last step) -->
					{#if index < content.steps.length - 1}
						<div class="flex justify-center">
							<div class="h-px w-24 bg-border"></div>
						</div>
					{/if}
				{/if}
			{/each}
		</div>
	{/if}
</div>